import React from "react";
import { Helmet } from "react-helmet";
import HirePageBanner from "../components/HirePageBanner/HirePageBanner";
import DevelopmentPerformance from "../components/DevelopmentPerformance/DevelopmentPerformance";
import SecondFaq from "../components/secondFaq/SecondFaq";
import Footer from "../components/footer/Footer";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import HirePageExperties from "../components/hirepageExperties/HirePageExperties";
import HirePageSteps from "../components/hire-page-steps/HirePageSteps";
import HireExpertFacts from "../components/hire-expert-facts/HireExpertFacts";
import HirePageEngagmentModels from "../components/hire-page-engagment-models/HirePageEngagmentModels";
import HirePageAppIdea from "../components/hire-page-app-idea/HirePageAppIdea";
import ContactSection from "../components/contactSection/ContactSection";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import HireCombinationSection from "../components/hire-combination-sectiono/HireCombinationSection";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import { useTranslation } from "react-i18next";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import SimpleModels from "../components/simpleEngagementModels";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import OurServices from "../components/our-services/OurServices";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import { comapnyCtaContent } from "../data/hireFlutterPageData";

const HireFluter = () => {
  const { t } = useTranslation("hireFlutterPage");
  const helmet = t("helmet", { returnObjects: true });
  const mainBanner = t("mainBanner", { returnObjects: true });
  const flutterExpertise = t("flutterExpertise", { returnObjects: true });
  const whyChooseUs = t("whyChooseUs", { returnObjects: true });
  const techCombinations = t("techCombinations", { returnObjects: true });
  const hireSteps = t("hireSteps", { returnObjects: true });
  const coverTheStack = t("coverTheStack", { returnObjects: true });
  const expertFacts = t("expertFacts", { returnObjects: true });
  const appIdeaSection = t("appIdeaSection", { returnObjects: true });
  const hirePageEngagementModels = t("hirePageEngagementModels", {
    returnObjects: true,
  });
  const faqSection = t("faqSection", { returnObjects: true });

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("hireFlutterTitle", { returnObjects: false });

  const { t: tengagementModelContent } = useTranslation(
    "engagementModelContent"
  );

  // grab the full object once
  const engagementModelsContent = {
    heading: tengagementModelContent("heading"),
    darkHeading: tengagementModelContent("darkHeading"),
    subheading: tengagementModelContent("subheading"),
    models: tengagementModelContent("models", { returnObjects: true }),
    cta: tengagementModelContent("cta", { returnObjects: true }),
  };

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>Hire Flutter Developers | Cross-Platform AI-Powered Mobile Experts for iOS & Android</title>
        <meta name="description" content="Hire Flutter developers from Bitsclan with proven AI experience. We build high-performance, cross-platform mobile apps with AI-powered personalization, chatbots and smart analytics for iOS and Android." />
      </Helmet>

      <MegaMenu />

      <ServicesPageBanner
        shortHeading={mainBanner?.shortHeading}
        mainHeading={mainBanner?.mainHeading}
        description={mainBanner?.content}
      />
      <TrustedPartner />

      <OurServices
        shortHeading={flutterExpertise?.shortHeading}
        mainHeading={flutterExpertise?.heading}
        description={flutterExpertise?.description}
        servicesCardsData={flutterExpertise?.servicesData}
        buttonText="Start Your Flutter Project"
      />

      <NewTestimonials
        shortHeading=" Some of Our Happy Clients"
        mainHeading="What Our Clients Say About Bitsclan's <span>Flutter Expertise</span>"
        description="We take pride in our flutter app development services, earning positive feedback from clients who value our dedication, quality, & reliable results. Their satisfaction inspires us to deliver exceptional mobile solutions every time."
      />

      <WhyChooseUs
        shortHeading={whyChooseUs?.shortHeading}
        greenHeading={whyChooseUs?.greenHeading}
        heading={whyChooseUs?.mainHeading}
        content={whyChooseUs?.description}
        stats={whyChooseUs?.statsData}
      />

      <NewCaseStudySection
        shortHeading="Our Flutter Development Success Stories"
        heading="Proven Flutter Solutions Driving Real-World Results"
        description="Through our Flutter development services, we’ve created dynamic, high-performing applications that align with client goals. We deliver innovative flutter solutions, blending speed, design, & functionality to surpass client's expectations & ensure measurable business growth."
      />

      {/* <DevelopmentPerformance
        buttonText={whyChooseUs.btnText}
        heading={whyChooseUs.heading}
        greenHeading={whyChooseUs.greenHeading}
        subHeading={whyChooseUs.subHeading}
        solutions={whyChooseUs.solutionsData}
      /> */}

      <HireCombinationSection
        shortHeading={techCombinations?.shortHeading}
        combinations={techCombinations.combinations}
        heading={techCombinations.heading}
        description={techCombinations.description}
      />

      <HirePageSteps
        buttonText={hireSteps.btnText}
        heading={hireSteps.heading}
        subHeading={hireSteps.subHeading}
        steps={hireSteps.steps}
      />

      <CoverTheStack
        shortHeading={coverTheStack?.shortHeading}
        whereStart={coverTheStack.whereStart}
        mainHeading={coverTheStack.mainHeading}
        subHeading={coverTheStack.subHeading}
        tabs={coverTheStack.tabs}
        tabItems={coverTheStack.tabItems}
      />

      {/* <HireExpertFacts
        buttonText={expertFacts.btnText}
        heading={expertFacts.heading}
        greenHeading={expertFacts.greenHeading}
        facts={expertFacts.facts}
        diffBannerBackgroundImage={expertFacts.backgroundImage}
      />

      <HirePageAppIdea
        heading={appIdeaSection?.heading}
        content={appIdeaSection.content}
      /> */}

      {/* <HirePageEngagmentModels
        buttonText={hirePageEngagementModels.btnText}
        heading={hirePageEngagementModels.headingContent}
        content={hirePageEngagementModels.discription}
        hiringDetails={hirePageEngagementModels.hiringDetails}
      /> */}

      {/* <SimpleModels content={engagementModelsContent} /> */}

      <TrendsInsights heading="Expert Insights to Accelerate Your Flutter App Success" description="Our Flutter specialists reveal practical techniques, frameworks, & trending solutions for mobile app development. We guide businesses & teams to streamline processes, enhance app performance, & deliver outstanding user experiences across iOS & android platforms with Flutter’s versatile capabilities." specificClass="mobile-dev-page" category="all" />

      <SecondFaq
        specificClass="mobile-dev-page"
        faqs={faqSection.faqData}
        mainHeading={faqSection.mainHeading}
        subHeading={faqSection.subHeading}
      />

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={comapnyCtaContent} />

      <Footer />
    </>
  );
};

export default HireFluter;
